/**
 * Created JS
 * User: JiangYilong
 * Date: 2018/7/26
 * Time: 11:41
 * Email: jiangyilong@wafersystems.com
 */
import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import Delay from '../components/delay/index';

const Index = ({ intl, dispatch, account }) => {
  return <Delay intl={intl} dispatch={dispatch} account={account} />;
};
export default connect(state => state)(injectIntl(Index));



// WEBPACK FOOTER //
// ./src/routes/Delay.js